import { useDarkMode } from "../../../context/ThemeContext";

export default function HistorialSection() {
  const { isDarkMode } = useDarkMode();

  const themeClasses = {
    bg: isDarkMode ? "bg-dark-bg" : "bg-white",
    text: isDarkMode ? "text-white" : "text-gray-900",
    textSecondary: isDarkMode ? "text-gray-400" : "text-gray-600",
    cardBg: isDarkMode ? "bg-dark-surface" : "bg-white",
    cardBorder: isDarkMode ? "border-dark-border" : "border-gray-200",
  };

  return (
    <div className="w-full h-full p-6 overflow-auto">
      <div className="mb-6">
        <h1 className={`text-2xl font-bold ${themeClasses.text}`}>
          Historial de Cobranza
        </h1>
        <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
          Registro histórico de todos los movimientos de cobranza
        </p>
      </div>

      <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-6`}>
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <i className={`ri-history-line text-6xl ${themeClasses.textSecondary} mb-4`}></i>
            <p className={`text-lg ${themeClasses.textSecondary}`}>
              No hay movimientos en el historial
            </p>
            <p className={`text-sm ${themeClasses.textSecondary} mt-2`}>
              Los pagos y adeudos aparecerán aquí
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
